import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class ChannelViewModel {
    ShowAlert:       (pTitle: string, pMessage: string) => void;
    BackToSignIn:    ()                                 => void;
    NewLoading:      (pMessage: string)                 => dmLoading;

    mlText:          MLText;
    app:             mlBroker;
    ml:              mlBroker;
    Hotel:           dmHotel;
    LangID:          number;

    HotelChainID:    number;
    SelectedChainID: number;
    ChainName:       string;
    HasProvider:     boolean;

    Providers:       RQService.Ota.GetHotelChainXMLProvidersRow[];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText       = pMLText;
        this.LangID       = this.mlText.GetLangID();
        this.app          = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml           = this.mlText.GetBroker(
            'HotelAreaChannel'
        );

        this.Hotel        = pHotel;
        this.BackToSignIn = pBackToSignIn;
        this.ShowAlert    = pShowAlert;
        this.NewLoading   = pNewLoading;

        this.Providers    = [];

        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            RQService.Ota.GetHotelChainXMLProviders({}).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let providers = response.RQueryResult;
            
                for (let i = 0; i < providers.length; i++) {
                    let provider = RQService.Ota.PopulateGetHotelChainXMLProvidersRow(
                        providers[i]
                    );
            
                    console.log('row push');
            
                    this.Providers.push(provider);
                }

                let hotelProviderParams = RQParam.OtaGetHotelXMLProviderParams();

                hotelProviderParams.HotelID = this.Hotel.HotelID;

                RQService.Ota.GetHotelXMLProvider(hotelProviderParams).then((result) => {
                    let response = result as any;

                    if (response.HasErrorOrException) { loading.Dismiss(); return; }

                    let hotelProvider = response.RQueryResult;

                    if (hotelProvider.length > 0) {
                        this.HasProvider     = true;

                        let currentProvider  = RQService.Ota.PopulateGetHotelXMLProviderRow(
                            hotelProvider[0]
                        );

                        this.HotelChainID    = currentProvider.HotelChainID;
                        this.ChainName       = currentProvider.ChainName;

                        this.SelectedChainID = this.HotelChainID;
                    } else {
                        this.HasProvider     = false;

                        this.HotelChainID    = 0;
                        this.ChainName       = '';

                        this.SelectedChainID = 0;
                    }

                    loading.Dismiss();
                });
            });
        });
    }

    public SelectProvider(pHotelChainID: number) {
        this.SelectedChainID = pHotelChainID;
    }

    public SetProvider() {
        if (this.SelectedChainID == 0) { return; }

        let saveParams = RQParam.OtaAssignHotelToChainParams();

        saveParams.HotelID      = this.Hotel.HotelID;
        saveParams.HotelChainID = this.SelectedChainID;
        saveParams.LangID       = this.LangID;

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            RQService.Ota.AssignHotelToChain(saveParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.HasProvider  = true;
                this.HotelChainID = this.SelectedChainID;

                for (let i: number = 0; i < this.Providers.length; i++) {
                    if (this.Providers[i].HotelChainID == this.HotelChainID) {
                        this.ChainName = this.Providers[i].ChainName;
                    }
                }

                loading.Dismiss();
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/channel/xv-channel.ts